import $ from 'jquery';

$(() => {
  $('.interface_block input[type=radio]').change(e => {
    const target = $(e.target);
    const p = target.closest('.interface_block');
    switch (p.find('input[type=radio]:checked').val()) {
      case 'manual':
        p.find('[class*="system_config_ip_address_"]:hidden').show();
        p.find('[class*="system_config_ip_netmask_"]:hidden').show();
        p.find('.badge').addClass('text-bg-primary');
        p.find('.badge').removeClass('text-bg-secondary');
        break;
      case 'dhcp':
        p.find('[class*="system_config_ip_address_"]:visible').hide();
        p.find('[class*="system_config_ip_netmask_"]:visible').hide();
        p.find('.badge').addClass('text-bg-primary');
        p.find('.badge').removeClass('text-bg-secondary');
        break;
      case 'off':
        p.find('[class*="system_config_ip_address_"]:visible').hide();
        p.find('[class*="system_config_ip_netmask_"]:visible').hide();
        p.find('.badge').removeClass('text-bg-primary');
        p.find('.badge').addClass('text-bg-secondary');
        break;
    }
  }).change();

  // show only recommended downloads on system/show
  $('body.resource_system input#system-show-recommended')
    .prop('checked', true)
    .change(e => $('table.downloadlist').toggleClass('show_notrecommended', $(e.target).checked))
    .change();

});

